/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthScopes } from './AuthScopes';
import {
    AuthScopesFromJSON,
    AuthScopesFromJSONTyped,
    AuthScopesToJSON,
} from './AuthScopes';

/**
 * 
 * @export
 * @interface UpsertRoleRequest
 */
export interface UpsertRoleRequest {
    /**
     * 
     * @type {Array<AuthScopes>}
     * @memberof UpsertRoleRequest
     */
    scopes: Array<AuthScopes>;
    /**
     * 
     * @type {string}
     * @memberof UpsertRoleRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertRoleRequest
     */
    name: string;
}

/**
 * Check if a given object implements the UpsertRoleRequest interface.
 */
export function instanceOfUpsertRoleRequest(value: object): value is UpsertRoleRequest {
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpsertRoleRequestFromJSON(json: any): UpsertRoleRequest {
    return UpsertRoleRequestFromJSONTyped(json, false);
}

export function UpsertRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scopes': ((json['scopes'] as Array<any>).map(AuthScopesFromJSON)),
        'description': json['description'],
        'name': json['name'],
    };
}

export function UpsertRoleRequestToJSON(value?: UpsertRoleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'scopes': ((value['scopes'] as Array<any>).map(AuthScopesToJSON)),
        'description': value['description'],
        'name': value['name'],
    };
}

